import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { border } from '../../../../style'
import { StyledFormElement as FormElement } from '../../../common/FormElement'
import Text from 'common/components/Text'
import { BoardIcon, FolderIcon } from 'common/components/Icon'
import DragTagContainer from './DragTagContainer'

const DragTag = styled(({ item, className }) => {
  if (!item) return null
  return (
    <FormElement className={className}>
      {item.type === 'board' ? (
        <BoardIcon color={item.color} />
      ) : (
        <FolderIcon color={item.color} />
      )}
      <Text black medium>
        {item.name}
      </Text>
    </FormElement>
  )
})(({ x, y }) => ({
  label: 'DragTag',
  pointerEvents: 'none',
  position: 'absolute',
  top: y,
  left: x,
  background: 'white',
  border: border,
  borderRadius: 2
}))

DragTag.propTypes = {
  className: PropTypes.string,
  dragging: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),
  item: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string
  })
}

export default DragTagContainer(DragTag)
